angular.module('HarvestingModule', [
	'HarvestingFactory', 
])

